module.exports = __webpack_public_path__ + "static/media/icon_members.a69a429f.png";